module.exports = __webpack_public_path__ + "static/media/photo308.8c0adeea.jpg";